import { Button, Flex, Text } from '@chakra-ui/react';

import { LoadMoreErrorProps } from './types';

function LoadMoreError({
  onRetry,
  isRetrying = false,
  'data-testid': dataTestId = 'load-more-error',
}: LoadMoreErrorProps) {
  return (
    <Flex
      data-testid={dataTestId}
      role="alert"
      align="center"
      justify="center"
      gap="12px"
      py="12px"
    >
      <Text textStyle="smallRegular" color="brand.darkGray">
        Couldn&apos;t load more
      </Text>
      <Button
        data-testid={`${dataTestId}-retry-button`}
        variant="outline"
        size="sm"
        isLoading={isRetrying}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Flex>
  );
}

export default LoadMoreError;
